import { Link } from 'react-router-dom';
const WelcomeBlock = (props) => {
	return (
		
			<div className="container ">
				<div className="section-head text-center">
					<h1><span className="site-text-primary">
					<span className="color1">W</span><span className="color2">e</span><span className="color3">l</span><span className="color4">c</span><span className="color5">o</span><span className="color6">m</span><span className="color7">e </span>
					 <span className="color4">to </span> </span> <span className="color3">{process.env.REACT_APP_SITE_TITLE} </span></h1>
					<div className="wt-separator-outer ">
						<div className="wt-separator style-icon">
							<i className="fa fa-leaf text-black"></i>
							<span className="separator-left site-bg-primary"></span>
							<span className="separator-right site-bg-primary"></span>
						</div>                            
					</div>
					
					<p className="font-16"><strong>
					{process.env.REACT_APP_SITE_TITLE} has establish in {process.env.REACT_APP_COMPANY_ESTEBLISHMENT_YEAR}. Aim to provide the quality base education in the rural and semi rural region.
					  </strong>
					</p>
					
				</div>
				<div className="section-content text-center about-spa m-b30">
					<p>
					{process.env.REACT_APP_SITE_TITLE} is one of the most prestigious schools in India. Founded as a Public School in {process.env.REACT_APP_COMPANY_ESTEBLISHMENT_YEAR} in Jaipur, it is a private School. {process.env.REACT_APP_SITE_TITLE}, is affiliated to the Rajasthan Board of Secondary Education (RBSE), which is the largest educational board in the country. It is recognised by the Department of Education, Govt. of Rajasthan. Life at {process.env.REACT_APP_SITE_TITLE} on a shared commitment to academic excellence, intellectual growth, art, athletics, high standards of ethical awareness, sportsmanship, and community service. The school's traditions and accessibility to a broad curriculum add depth to each student’s life. The school upholds the founders' commitment to excellence in all fields, with emphasis on its motto Service Before Self.
					</p>
					<div className="row d-flex justify-content-center">
						<div className="col-lg-4 col-md-6 m-b30">
							<div className="wt-icon-box-wraper p-a30 center">
								<div className={`wt-icon-box-md  ${props.radius ? " radius " : ""}  bg-wbox m-b20 circle-line-effect`}>
									<span className="icon-cell text-white"><span className="flaticon-team"></span><i className="flaticon2-graph-1"></i></span>
								</div>
								<div className="icon-content">
									<h4 className="wt-tilte font-weight-500">Principal Message</h4>
									<p className="text-secondry">To Learning about a Letter World, We All have to strive together with vision courage and with Optimism, in school the student come to live, learn and success has to be earned and it demands sustained hard work, discipline and confidence. If you are willing to work, diligently towards your goal it will surely received.</p>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 m-b30">
							<div className="wt-icon-box-wraper p-a30 center">
								<div className={`wt-icon-box-md  ${props.radius ? " radius " : ""}  bg-wbox1 m-b20 circle-line-effect`}>
									<span className="icon-cell text-white"><span className="flaticon-envelope"></span></span>
								</div>
								<div className="icon-content">
									<h4 className="wt-tilte font-weight-500">Chairman Message</h4>
									<p className="text-secondry">As a philanthropist I have a vision to build a strong motion and a prosperous society. To realize this vision I have channelized my efforts towards the noble field of education in the chomu jaipur. With the vision of my dedicated commitment and devoted endeavors of providing sustainable.</p>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 m-b30">
							<div className="wt-icon-box-wraper p-a30 center">
								<div className={`wt-icon-box-md  ${props.radius ? " radius " : ""}  bg-wbox2 m-b20 circle-line-effect`}>
									<span className="icon-cell text-white"><span className="flaticon-mirror"></span></span>
								</div>
								<div className="icon-content">
									<h4 className="wt-tilte font-weight-500">Secretary Message</h4>
									<p className="text-secondry">Down the ages, our concept of education has undergone a gradual metamorphosis. Yet the itemize values and principles have generally remained unchanged. Education isn’t how much you have committed to memory or even how much you know.</p>
								</div>
							</div>
						</div>
						
					</div>
					<div>
						<Link to="shortcode-pricing-table" className="m-b15 site-button text-uppercase radius-sm m-lr15 font-weight-700 button-lg" >More Detail</Link>
						
					</div>
				</div>
			</div>
  	
	);
};
WelcomeBlock.defaultProps = {
    radius:"radius",
}
export default WelcomeBlock;
